import { Box, ButtonBase, CardMedia, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
const sharedTypographyStyle = {
  textAlign: "center",
  color: "#FFF",
  fontFamily: "Roboto",
  fontSize: "25px",
  fontStyle: "normal",
};
interface EmptySuiteHistoryProps {
  suiteRouting: string;
  suiteClass: string;
  suiteHeader: string;
  suiteMessage: string;
  removeButton?: boolean;
}
const EmptySuiteHistory = ({
  suiteRouting,
  suiteClass,
  suiteHeader,
  suiteMessage,
  removeButton,
}: EmptySuiteHistoryProps) => {
  const navigate = useNavigate();
  const handleNavigateToApps = () => {
    navigate(suiteRouting);
  };

  return (
    <Box
      sx={{
        position: "relative",
        flexGrow: 1,
        width: "100%",
      }}
    >
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          position: "absolute",
          top: "30%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <CardMedia
          component={"img"}
          className={suiteClass}
          alt="empty-suite-history.png"
          sx={{
            my: 1,
            width: { xs: "300px", md: "375px" },
            height: { xs: "300px", md: "375px" },
            objectFit: "contain",
          }}
        />
        <Box
          sx={{
            mt: { xs: -10, md: -15 },
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography
            className="empty-history-text"
            sx={{ ...sharedTypographyStyle, fontWeight: 600 }}
          >
            {suiteHeader}
          </Typography>
          <Typography
            className="empty-history-text"
            sx={{
              my: 1,
              ...sharedTypographyStyle,
              fontSize: "17px",
              fontWeight: 500,
              opacity: 0.7,
            }}
          >
            {suiteMessage}
          </Typography>
          {!removeButton && (
            <ButtonBase
              onClick={handleNavigateToApps}
              sx={{
                mt: 3,
                backgroundColor: "#12B6EA",
                borderRadius: "16px",
                width: { xs: "95%", sm: "80%", md: "30%" },
                py: "12px",
                color: "#FFF",
              }}
            >
              {"Explore Apps Now"}
            </ButtonBase>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default EmptySuiteHistory;
